module.exports = __webpack_public_path__ + "static/img/Createacomb-active.f65774aa.svg";